import axios from 'axios'
import { SAVINGS_PLAN_ENDPOINT } from 'common/backend/endpoints'
import { ErrorAction } from 'common/redux/toasts'

export async function deleteSavingsPlan(id) {
    const endpoint = `${SAVINGS_PLAN_ENDPOINT}/${id}`
    try{
        const data = await axios.delete(endpoint)
        return data
    }catch(error){
        ErrorAction({ title: error.response.data.message || "Hubo un error. No se pudo eliminar el producto." });
    }

}
